<template lang="pug">
  div
    v-card-title
      v-row
        v-col(cols="12" md="2")
          v-toolbar-title(style="color: grey") Custom Filter :
        v-col(cols="12" md="5" sm="6")
          v-select(
            label="Status",
            :items="formStatus",
            v-model="statusSelect",
            item-value="value" 
            multiple,
            hide-details,
          )
        v-col(cols="12" md="5" sm="6")
          v-text-field(
            v-model="search",
            append-icon="mdi-magnify",
            label="Search",
            single-line,
            hide-details
          )
    v-data-table.elevation-1(
      :headers="ip.headers"
      :sort-desc.sync="ip.ipDateFormat"
      :items="ip.items"
      :single-expand="true"
      :expanded.sync="expanded"
      item-key="ipNo"
      show-expand
      :search='search'
      :page.sync="page"
      :options.sync="options"
      :server-items-length="ip.jumlah"
      :loading="loading"
      loading-text="Loading... Please wait"
      multi-sortBy
      :footer-props="{'items-per-page-options':[5, 10, 15]}"
      :items-per-page="10"
    )
      template(v-slot:item.ipStatusLabel="{ item }")
        v-chip(
          label,
          small,
          :color="config.status[item.ipStatusColor].color",
          style="width: 100%; justify-content: space-evenly",
          text-color="black"
        ) {{ item.ipStatusLabel }}
      template(v-slot:item.actions="{ item }")
        v-icon(
          small 
          class='mr-2' 
          color="blue" 
          dark
          @click="getPreview(item._id, 'openJangkaPendekView');"
          v-if="item.ipForm == config.FormCode.izinJangkaPendek"
        ) remove_red_eye
        JangkaPendekExtendView(
          v-if="item.ipForm == config.FormCode.izinJangkaPendek"
          :dialogType="dialogType"
          :ip="itemView"
          :approvalUser="userAuth"
          title="Preview"
          ref="openJangkaPendekView"
        )
  
        v-icon(
          small 
          class='mr-2' 
          color="blue" 
          dark
          v-if="allowPrint(item)"
          @click="getPrintPreview(item._id);"
        ) print
        PrintEwaskatPDF(
          :ip="itemView"
          :approvalUser="userAuth"
          title="Preview"
          ref="PritView"
          typeWaskat="extendWaskat"
        )
  
        v-icon(
          small 
          class='mr-2' 
          color="green" 
          dark
          @click.stop="editEstimate(item)"
          v-if="[1, 3].includes(item.ipExtendStatus) && item.ipExtendUser.email === userAuth.email"
        ) edit
        v-dialog(v-if="dialogType === 'approval'" v-model="perpanjanganDialog" persistent max-width="500px")
          v-card()
            v-card-title(class="headline grey lighten-2") Perpanjangan Form
            v-card-text(class="pt-5")
              v-layout(wrap)
                v-flex(xs12) 
                  | Estimasi Waktu Pekerjaan *
                v-flex(xs6)
                  v-menu(
                    ref="startEstimasi"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                    id="fjp-estimasi-start-menu")
                    template(v-slot:activator="{ on }")
                      v-text-field(
                        v-model="startDate"
                        label="mulai dari"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                        id="fjp-estimasi-start-input")
                    v-date-picker(id="fjp-estimasi-start-picker" v-model="startDate" :min="estimateMinDate" :allowed-dates="estimateAllowedDatesStart")
                      v-spacer
                      v-btn(text color="primary" @click="$refs.startEstimasi.save(startDate)") OK
                v-flex(xs6)
                  v-menu(
                    ref="endEstimasi"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                    id="fjp-estimasi-end-menu")
                    template(v-slot:activator="{ on }")
                      v-text-field(
                        v-model="endDate"
                        label="sampai dengan"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                        id="fjp-estimasi-end-input")
                    v-date-picker(show-current="false" v-model="endDate" :min="startDate || estimateMinDate" :allowed-dates="estimateAllowedDatesEnd" id="fjp-estimasi-end-picker")
                      v-spacer
                      v-btn(text color="primary" @click="$refs.endEstimasi.save(endDate)") OK
            v-card-actions
              v-spacer
              v-btn(text @click.native="perpanjanganDialog = false") Close
              v-btn(text :loading="perpanjanganDialog2" color="blue darken-1" @click="perpanjanganDialog2 = true") Submit
              v-dialog(
                v-model="perpanjanganDialog2"
                hide-overlay
                persistent
                width="300")
                v-card(color="primary" dark)
                v-card-text Processing. Please wait!
                  v-progress-linear(indeterminate color="white" class="mb-0")
  
      template(v-slot:expanded-item="{ headers, item }")
        td(:colspan="headers.length")
          v-container(grid-list-md)
            v-layout(row, wrap)
              v-flex(xs12)
                v-toolbar(dense, dark, color="cyan")
                  v-icon(style="font-size: 28px") timeline
                  v-toolbar-title.subheading Approval Timeline
                  v-spacer
  
                v-timeline(
                  v-if="item.ipForm == 'BIB-HSE-PPO-FRM-018-03'",
                  align-top,
                  dense
                )
                  v-timeline-item(color="teal accent-3", icon="edit")
                    v-row.pt-1
                      v-col
                        strong {{ getWITADate(item.ipExtendDate) }} - {{ item.ipExtendStatus == 1 ? 'Drafted by' : 'Submited by' }} {{ item.ipUser.name }} ({{ item.ipUser.title }} ) as Creator
                  v-timeline-item(
                    v-for="(workflow, index) in item.ipExtendWorkflow",
                    :key="workflow.date",
                    :color="workflow.status == 9 ?  config.status[6].color : config.status[workflow.status].color",
                    :icon="workflow.status == 9 ?  config.status[6].icon : config.status[workflow.status].icon"
                  )
                    v-row.pt-1(
                      v-if="workflow.status == 7 || workflow.status == 8"
                    )
                      v-col
                        strong(v-if="workflow.admin_reject == true") {{ getWITADate(workflow.date) }} - {{ config.status[workflow.status].name }} by {{ workflow.admin_detail.name }} ({{ workflow.admin_detail.title }}) as Admin
                        strong(v-else) {{ getWITADate(workflow.date) }} - {{ config.status[workflow.status].name }} by {{ workflow.name }} ({{ workflow.postAs == "waskat"? "HSE" : workflow.postAs == "karyawan" ? "Teknisi" : workflow.postAs == "atasan" ? "Lead" : workflow.postAs == "secHead" ? "Lead" : "Lead"}}) as {{ timelineDetail(workflow.postAs, index) }}
                        .caption.mb-2 {{ workflow.comment }}
                    v-row.pt-1(v-else)
                      v-col
                        strong {{ timelineDetail(workflow.postAs, index) }}
                  v-timeline-item(
                    :icon="item.ipExtendStatus == 12  ? 'check' : ''",
                    :color="item.ipExtendStatus == 12  ? 'blue' : 'grey'"
                  )
                    v-row.pt-1
                      v-col
                        strong Done
  </template>
  
  <script>
  import axios from "axios";
  import * as config from "../config/index.json";
  import JangkaPendekExtendView from "@/components/JangkaPendekExtendView";
  import PrintEwaskatPDF from "@/components/PrintEwaskatPDF.vue";
  import { mapGetters, mapState } from "vuex";
  import moment from "moment";
  import helper from "../helper/index.js";
  export default {
    name: "EwaskatExtendList",
    components: {
      JangkaPendekExtendView,
      PrintEwaskatPDF
    },
    props: {
      title: String,
      dialogType: String,
      ip: Object,
    },
    data() {
      return {
        search: "",
        expanded: [],
        formName: config.FormName,
        formStatus: [
          { text: "All", value: -1 },
          { text: "Draft", value: 1 },
          { text: "On Approval", value: 2 },
          { text: "Need Approval", value: 9 },
          { text: "Need Review", value: 3 },
          { text: "Fully Approved", value: 4 },
          { text: "Rejected", value: 8 },
          { text: "On Closing", value: 10 },
          { text: "Need Closing", value: 20 },
          { text: "Need Evaluation", value: 11 },
          { text: "Done", value: 12 },
          { text: "Auto Dropped", value: 15 },
          { text: "Auto Cancelled", value: 13 },
          { text: "Auto Rejected", value: 14 },
        ],
        config: config.default,
        dialog: false,
        formSelect: "",
        pagination: {
          sortBy: ["ipDate"],
          descending: [true],
        },
        docPelaporan: null,
        inputModal: {},
        options:{
          sortBy: ['ipDate'],
          sortDesc: [true]
        },
        loading: false,
        request:null,
        page: 1,
        itemsPerPage: 10,
        statusSelect: [9],
        itemView: {},
        perpanjanganDialog: false,
        perpanjanganDialog2: false,
        startEstimasi: false,
        endEstimasi: false,
        startDate: null,
        endDate: null,
        comment: '',
        ipNo: ''
      };
    },
    beforeDestroy(){
      this.$store.state.extendEwaskatList.data = [];
      this.$store.state.extendEwaskatList.totalData = 0
    },
    computed: {
      ...mapState([ "API_URL" ]),
      ...mapGetters(['userAuth']), // get user data login with combine leave user
      estimateMinDate: function () {
        return moment().format('YYYY-MM-DD');
      },
    },
    methods: {
      getWITADate: helper.getWITADate,
      timelineDetail(postAs, index) {
        switch (postAs) {
          case "deptHead":
            return "DIC / Kustodian";
          case "divHead":
            return "Div.Head / Cust Div.head";
          case "custodianDeptHead":
            return "Custodian Dept Head";
          case "custodianDivHead":
            return "Custodian Div Head";
          case "ohsDeptHead":
            return "OHS Dept Head";
          case "hseDivHead":
            return "HSE Div Head";
          case "approver":
            return "KTT";
          case "teamLeader":
            return "Team Leader / Custodian Dept Head / Sec Head";
          case "pjo":
          case "secHead":
            return "Atasan / PJO / Section Head";
          case "karyawan":
            return "Pekerja";
          case "waskat":
            return `Waskat ${index + 1}`;
          case "atasan":
            return `Atasan / PJO / Section Head`;
          case "requestor":
            return "PJO/Section Head";
          case "verificator1": 
            return "DIC/Custodian";
          case "verificator2": 
            return "OHS Departemen";
          case "safetyInternal": 
            return "Safety Internal";
          default:
            return "approverDefault";
        }
      },
      cancel(){
        this.request.cancel()
      },
      getOptions() {
        clearTimeout(this._timerId)
        if(this.request) this.cancel();
  
        this._timerId = setTimeout(()=>{
          this.$store.state.extendEwaskatList.data = [];
          this.loading = true;
  
          if ( this.options.page == undefined ) {
            this.options.page = 1
          }
  
          if ( this.options.rowsPerPage == undefined ) {
            this.options.rowsPerPage = this.itemsPerPage
          }
          
          const axiosSource = axios.CancelToken.source()
          this.request = {cancel:axiosSource.cancel}
          
          if (this.options.sortBy) {
            const direction = this.options.sortDesc[0] ? 'desc' : 'asc';
            let sortBy = this.options.sortBy;
  
            if (sortBy[0] == "ipDateFormat") {
              sortBy = ["ipDate"];
            } else if ( sortBy[0] == "ipFormShortName" ) {
              sortBy = ["ipForm"]
            }
  
            let statusForm = this.statusSelect
  
            if ( statusForm.length < 1 ) {
              statusForm = [-1]
            } else if ( statusForm.length > 1 && statusForm.slice(-1) == -1 ) {
              statusForm = [-1]
              this.statusSelect = [-1]
            } else if ( statusForm.length > 1 && statusForm[0] == -1 ) {
              statusForm.splice(0, 1)
            }
  
            let formSelect = this.formSelect
  
            if ( formSelect.length <= 1 && formSelect[0] == "all" ) {
              formSelect = ""
            } else if ( formSelect.length > 1 && formSelect.slice(-1) == "all" ) {
              formSelect = ""
              this.formSelect = ["all"]
            } else if ( formSelect.length > 1 && formSelect[0] == "all" ) {
              formSelect.splice(0, 1)
            }
  
            axios.get(
              `${this.$store.state.API_URL}/v1/requests/waskat/extend`, 
              {
                params: {
                  email: this.userAuth.email,
                  desiredStatus: statusForm != null ? JSON.stringify(statusForm) : JSON.stringify([9]),
                  forms: formSelect != "" ? JSON.stringify(formSelect) : [],
                  searchQuery: this.search,
                  sortBy: sortBy[0],
                  order: direction,
                  page: this.options.page,
                  perPage: this.options.rowsPerPage,
                  userId: this.userAuth._id
                },
                headers: {"Authorization": `Bearer ${this.$store.state.token}`}
              }
              ).then(res => {
  
                this.page = this.options.page
                this.$store.state.extendEwaskatList.data = res.data.data;
                this.$store.state.extendEwaskatList.jumlah = res.data.totalData;
                this.$store.state.extendEwaskatList.desiredStatus = res.data.desiredStatus;
                this.request=null
                this.$store.state.loader = false;
              })
              .catch(err => {
                console.log(err)
                this.$store.state.loader = false;
                this.$snackbar.showMessage({ message: err.response.data.message, color: 'red' });
              })
              .finally(() => {
                this.loading = false
                this.$store.state.loader = false;
              });
          }
        },500)
      },
      getPreview(id, refComponent) {
          axios.get(
            `${this.$store.state.API_URL}/v1/requests/getById/` + id, 
            {
              headers: {"Authorization": `Bearer ${this.$store.state.token}`}
            }
          ).then(res => {
            this.itemView = res.data[0]
            this.$store.state.loader = false;
            this.$refs[refComponent].dialog = true;
          })
          .catch(err => {
            console.log(err)
            this.$store.state.loader = false;
          })
          .finally(() => {
            this.$store.state.loader = false;
          });
      },
      getPrintPreview(id) {
          axios.get(
            `${this.$store.state.API_URL}/v1/requests/printById/` + id, 
            {
              headers: {"Authorization": `Bearer ${this.$store.state.token}`}
            }
          ).then(res => {
            this.itemView = res.data
            this.$store.state.loader = false;
            if (Object.keys(this.itemView).length > 0) {
              this.$refs.PritView.dialog = true;
            }
          })
          .catch(err => {
            console.log(err)
            this.$store.state.loader = false;
          })
          .finally(() => {
            this.$store.state.loader = false;
          });
      },
      estimateAllowedDatesStart(val) {
        if (this.endDate) {
          return val <= moment(this.endDate).format('YYYY-MM-DD') && val > moment(this.endDate).subtract(14, 'days').format('YYYY-MM-DD');
        }
        return val
      },
      estimateAllowedDatesEnd(val) {
        return val < moment(this.startDate).add(14, 'days').format('YYYY-MM-DD');
      },
      editEstimate(item) {
        this.startDate = moment(item.ipExtendEstimateStart).format('YYYY-MM-DD');
        this.endDate = moment(item.ipExtendEstimateEnd).format('YYYY-MM-DD');
        this.comment = item.ipExtendComment;
        this.ipNo = item.ipNo;
        this.perpanjanganDialog = true;
      },
      allowPrint(item) {
        return item.ipExtendStatus === 4 
          && new Date(item.ipExtendEstimateEnd) > new Date()
          && this.userAuth.group_level.includes('PIC')
      },
    },
    watch: {
      options(val){
        this.itemsPerPage = val.itemsPerPage
        this.getOptions()
      },
      search() {
        this.getOptions()
      },
      formSelect() {
        this.page = 1
        this.getOptions()
      },
      statusSelect() {
        this.page = 1
        this.getOptions()
      },
      perpanjanganDialog2(val) {
        if (!val) return
        const formData = {
          ipNo: this.ipNo,
          estimateStart: this.startDate,
          estimateEnd: this.endDate,
          ipUser: this.userAuth
        }
        const config = {
          method: "post",
          url: `${this.API_URL}/v1/requests/waskat/extend/edit`,
          headers: {"Authorization": `Bearer ${this.$store.state.token}`},
          data: formData
        };
        axios(config).then(res => {
          if (res.status == 200) {
            setTimeout(() => {
              // this.$refs['perpanjanganDialog2'].dialog = false;
              this.perpanjanganDialog2= false;
              this.perpanjanganDialog= false;
              this.startDate= null;
              this.endDate= null;
              this.comment= '';
              this.ipNo= '';
              this.getOptions();
            },
            1000);
          }
        });
      }
    },
  };
  </script>
  
  <style>
  .pointer {
    cursor: pointer;
  }
  </style>